import { useMutation } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { catalogAccessRepository } from '@webapp/modules/purchasing/data-access/repositories/CatalogAccessRepository'

export const useLockAllCatalogItemsModel = () => {
  const { mutateAsync: lockAllCatalogItems, isLoading } = useMutation<
    void,
    RepoError,
    void
  >({
    mutationFn: () => catalogAccessRepository.lockAllCatalogItems(),
  })

  return { lockAllCatalogItems, isLoading }
}
